import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getLayersTs } from "../../ducks/layers/selectors";
import { setLayersTs } from "../../ducks/layers/layers";

export const useLayersTs = (): [Record<string, number>, (values: Record<string, number>) => void] => {
  const dispatch = useDispatch();
  const ts = useSelector(getLayersTs);

  const update = useCallback(
    (values: Record<string, number>) => {
      dispatch(setLayersTs(values));
    },
    [dispatch],
  );

  return [ts, update];
};
